<template>
  <div class="d-flex justify-content-end">
    <div class="w-100">
      <slot name="selects" />
    </div>

    <SModal
      v-model="showFilters"
      :show-footer-gradient="false"
      data-cy="sdui-filter-wrapper"
      body-class="pt-2 position-relative"
      :header-title="$t('classbook.filters.modal_title')"
      @hide="$emit('hide')"
      @close="$emit('close')"
    >
      <template #header-left-action v-if="!hideResetBtn">
        <b-button variant="link"
                  size="sm"
                  class="text-left mw-100 pl-0 py-0"
                  @click="resetFilters"
        >
          <span class="text-nowrap d-block text-truncate">{{ $t('classbook.filters.filter_delete_all_btn') }}</span>
        </b-button>
      </template>

      <VForm id="form-sdui-filter-wrapper"
             :initial-values="initialFormValues"
             @submit="saveFilters()"
      >
        <slot v-if="showFilters" />
      </VForm>

      <SModalPortalTo>
        <b-button variant="primary"
                  data-cy="submit-filter"
                  size="lg"
                  block
                  type="submit"
                  form="form-sdui-filter-wrapper"
        >
          <span>{{ $t('classbook.filters.filter_accept_btn') }}</span>
        </b-button>
      </SModalPortalTo>
    </SModal>
  </div>
</template>

<script>
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiFilterWrapper',
  components: { SModalPortalTo },
  props: {
    toggle: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      type: Object,
      default: () => ({}),
    },

    hideResetBtn: {
      type: Boolean,
      default: false,
    },

    initialFormValues: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showFilters: false,
  }),

  emits: ['update', 'hide', 'close', 'reset'],

  methods: {
    resetFilters() {
      this.$emit('reset')
      this.$emit('hide')
    },

    saveFilters() {
      this.$emit('update', this.modelValue)
    },
  },

  watch: {
    toggle: {
      async handler(newVal, oldVal) {
        if (newVal === oldVal) return
        this.showFilters = newVal
      },

      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
// TODO: fix naming to align with conventions
.customMinH {
  min-height: 48px !important;
}
// TODO: fix naming to align with conventions
.borderTop {
  border-top: 1px solid $color-gray-100;
}
</style>
